import React from 'react';
import { AiOutlinePlus } from "react-icons/ai";
import SharedPopupModal from './SharedPopupModal';

const SharedDataAddButton = ({ Component, popupModalProps}) => {



  // console.log(ComponentProps)
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  
  return (
    <div>
      <div className='bg-skin-button p-3 text-2xl rounded-full hover:bg-skin-button-hover' onClick={handleOpen}>
        <AiOutlinePlus />
      </div>
      <SharedPopupModal open={open} handleClose={handleClose} ChildComponent={Component} popupModalProps={popupModalProps}/>
    </div>
  );
};

export default SharedDataAddButton;
